<template>
  <div
    class="phone"
    :class="{ 'phone--dark': settings?.schema === 'dark' }"
    :style="{ backgroundColor: settings?.main?.bgColor }"
  >
    <div class="phone__status-bar">
      <img
        v-if="settings?.schema === 'dark'"
        src="/resources/images/phone/navbar-top-ios-dark.png"
        width="240px"
      />
      <img
        v-else
        src="/resources/images/phone/navbar-top-ios-light.png"
        width="240px"
      />
    </div>
    <div class="phone__header">
      <slot name="header"></slot>
    </div>
    <div class="phone__content">
      <slot name="content"></slot>
    </div>
    <div class="phone__footer" :style="{ background: bgColor }">
      <ul class="phone__menu">
        <li class="phone__menu-item active">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.1538 22H5.84615C3.72308 22 2 20.2774 2 18.1548V10.6388C2 9.43912 2.54359 8.33171 3.48718 7.60369L9.64103 2.81518C11.0359 1.72827 12.9744 1.72827 14.359 2.81518L20.5128 7.60369C21.4564 8.33171 22 9.43912 22 10.6388V18.1548C22 20.2774 20.2769 22 18.1538 22ZM12 3.54319C11.4974 3.54319 10.9949 3.70725 10.5846 4.02512L4.43077 8.81364C3.86667 9.25455 3.53846 9.92105 3.53846 10.6388V18.1548C3.53846 19.4263 4.57436 20.4619 5.84615 20.4619H18.1538C19.4256 20.4619 20.4615 19.4263 20.4615 18.1548V10.6388C20.4615 9.92105 20.1333 9.25455 19.5692 8.81364L13.4154 4.03538C12.9949 3.70725 12.5026 3.55345 12 3.55345V3.54319ZM15.0769 17.8985H8.92308C8.50256 17.8985 8.15385 17.5499 8.15385 17.1295C8.15385 16.709 8.50256 16.3604 8.92308 16.3604H15.0769C15.4974 16.3604 15.8462 16.709 15.8462 17.1295C15.8462 17.5499 15.4974 17.8985 15.0769 17.8985Z"
              fill="currentColor"
            />
          </svg>
          <span :style="{ color: settings?.main?.textColor }">Главная</span>
        </li>
        <li class="phone__menu-item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                d="M4.16055 4.21965C4.45344 3.92678 4.9284 3.92678 5.22129 4.21965C5.51417 4.51254 5.51416 4.9875 5.22129 5.28039C3.47891 7.02277 2.50001 9.38593 2.5 11.85C2.5 14.2756 3.44854 16.6034 5.14014 18.3375L5.22129 18.4196L5.24785 18.4477C5.51385 18.7421 5.50501 19.1967 5.22129 19.4804C4.93755 19.7641 4.48299 19.773 4.18857 19.507L4.16055 19.4804L4.06641 19.385C2.10167 17.3709 1 14.6672 1 11.85C1.00001 8.98811 2.13687 6.24333 4.16055 4.21965Z"
                fill="currentColor"
              />
              <path
                d="M18.5756 4.21965C18.8685 3.92678 19.3434 3.92678 19.6363 4.21965C21.66 6.24333 22.7969 8.98811 22.7969 11.85C22.7969 14.6672 21.6952 17.3709 19.7305 19.385L19.6363 19.4804L19.6083 19.507C19.3139 19.773 18.8593 19.7641 18.5756 19.4804C18.2919 19.1967 18.283 18.7421 18.549 18.4477L18.5756 18.4196L18.6567 18.3375C20.3483 16.6034 21.2969 14.2756 21.2969 11.85C21.2969 9.38593 20.318 7.02277 18.5756 5.28039C18.2827 4.9875 18.2827 4.51254 18.5756 4.21965Z"
                fill="currentColor"
              />
              <path
                d="M6.98486 6.93547C7.27775 6.64263 7.75263 6.64261 8.04551 6.93547C8.3384 7.22836 8.33839 7.70332 8.04551 7.99621C7.02345 9.01828 6.44922 10.4045 6.44922 11.8499C6.44922 13.2728 7.00564 14.6383 7.99795 15.6555L8.04551 15.7036L8.07207 15.7317C8.33805 16.0261 8.32922 16.4805 8.04551 16.7643C7.76177 17.048 7.30721 17.0569 7.01279 16.7909L6.98486 16.7643L6.92412 16.7029C5.65874 15.4057 4.94922 13.6644 4.94922 11.8499C4.94922 10.0067 5.68149 8.23884 6.98486 6.93547Z"
                fill="currentColor"
              />
              <path
                d="M15.7514 6.93547C16.0442 6.64261 16.5191 6.64263 16.812 6.93547C18.1154 8.23884 18.8477 10.0067 18.8477 11.8499C18.8477 13.6644 18.1381 15.4057 16.8728 16.7029L16.812 16.7643L16.7841 16.7909C16.4897 17.0569 16.0351 17.048 15.7514 16.7643C15.4677 16.4805 15.4588 16.0261 15.7248 15.7317L15.7514 15.7036L15.7989 15.6555C16.7912 14.6383 17.3477 13.2728 17.3477 11.8499C17.3477 10.4045 16.7734 9.01828 15.7514 7.99621C15.4585 7.70332 15.4585 7.22836 15.7514 6.93547Z"
                fill="currentColor"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.8992 9.39943C13.2523 9.39943 14.3492 10.4963 14.3492 11.8494C14.3492 13.2025 13.2523 14.2994 11.8992 14.2994C10.5461 14.2994 9.44922 13.2025 9.44922 11.8494C9.44922 10.4963 10.5461 9.39943 11.8992 9.39943ZM11.8992 10.8994C11.3745 10.8994 10.9492 11.3248 10.9492 11.8494C10.9492 12.3741 11.3745 12.7994 11.8992 12.7994C12.4239 12.7994 12.8492 12.3741 12.8492 11.8494C12.8492 11.3248 12.4239 10.8994 11.8992 10.8994Z"
                fill="currentColor"
              />
            </g>
          </svg>

          <span :style="{ color: settings?.main?.textColor }">Live</span>
        </li>
        <li class="phone__menu-item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.4615 22H5.53846C4.13538 22 3 20.8 3 19.3171V6.63415C3 5.15122 4.13538 3.95122 5.53846 3.95122H7.61538V2.73171C7.61538 2.33171 7.92923 2 8.30769 2C8.68615 2 9 2.33171 9 2.73171V3.95122H15V2.73171C15 2.33171 15.3138 2 15.6923 2C16.0708 2 16.3846 2.33171 16.3846 2.73171V3.95122H18.4615C19.8646 3.95122 21 5.15122 21 6.63415V19.3171C21 20.8 19.8646 22 18.4615 22ZM4.38462 10.2927V19.3171C4.38462 19.9902 4.90154 20.5366 5.53846 20.5366H18.4615C19.0985 20.5366 19.6154 19.9902 19.6154 19.3171V10.2927H4.38462ZM4.38462 8.82927H19.6154V6.63415C19.6154 5.96098 19.0985 5.41463 18.4615 5.41463H16.3846V6.63415C16.3846 7.03415 16.0708 7.36585 15.6923 7.36585C15.3138 7.36585 15 7.03415 15 6.63415V5.41463H9V6.63415C9 7.03415 8.68615 7.36585 8.30769 7.36585C7.92923 7.36585 7.61538 7.03415 7.61538 6.63415V5.41463H5.53846C4.90154 5.41463 4.38462 5.96098 4.38462 6.63415V8.82927ZM16.6154 18.0976H7.38462C7.00615 18.0976 6.69231 17.7659 6.69231 17.3659C6.69231 16.9659 7.00615 16.6341 7.38462 16.6341H16.6154C16.9938 16.6341 17.3077 16.9659 17.3077 17.3659C17.3077 17.7659 16.9938 18.0976 16.6154 18.0976ZM16.6154 14.1951H12H7.38462C7.00615 14.1951 6.69231 13.8634 6.69231 13.4634C6.69231 13.0634 7.00615 12.7317 7.38462 12.7317H16.6154C16.9938 12.7317 17.3077 13.0634 17.3077 13.4634C17.3077 13.8634 16.9938 14.1951 16.6154 14.1951Z"
              fill="currentColor"
            />
          </svg>

          <span :style="{ color: settings?.main?.textColor }">Линия</span>
        </li>
        <li class="phone__menu-item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5851 21.2C9.52408 21.2 6.63686 19.664 4.86976 17.104C4.638 16.7692 4.71525 16.3065 5.04357 16.08C5.37188 15.8437 5.82573 15.9225 6.04782 16.2572C7.54455 18.4332 9.97793 19.7329 12.5755 19.7329C16.9691 19.7329 20.5419 16.0898 20.5419 11.6098C20.5419 7.12985 16.9787 3.47692 12.5851 3.47692C8.19152 3.47692 4.61869 7.12 4.61869 11.6C4.61869 11.7378 4.61869 11.8757 4.62835 12.0234L5.55535 11.0782C5.83538 10.7926 6.29889 10.7926 6.57892 11.0782C6.85895 11.3637 6.85895 11.8363 6.57892 12.1218L4.40625 14.3372C4.12622 14.6228 3.66272 14.6228 3.38269 14.3372L1.21002 12.1218C0.929992 11.8363 0.929992 11.3637 1.21002 11.0782C1.49006 10.7926 1.95356 10.7926 2.23359 11.0782L3.17991 12.0431C3.17991 11.8954 3.17025 11.7477 3.17025 11.6C3.17025 6.30277 7.39005 2 12.5851 2C17.7802 2 22 6.30277 22 11.6C22 16.8972 17.7802 21.2 12.5851 21.2ZM15.8393 15.1643C15.7138 15.1643 15.5882 15.1348 15.4724 15.056L11.9478 12.9194C11.7257 12.7914 11.5905 12.5452 11.5905 12.2892V7.65169C11.5905 7.248 11.9188 6.91323 12.3147 6.91323C12.7107 6.91323 13.039 7.248 13.039 7.65169V11.8757L16.2159 13.7957C16.5635 14.0025 16.6697 14.4554 16.467 14.8098C16.3318 15.0462 16.0904 15.1742 15.8393 15.1742V15.1643Z"
              fill="currentColor"
            />
          </svg>

          <span :style="{ color: settings?.main?.textColor }">Мои ставки</span>
        </li>
        <li class="phone__menu-item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.2349 18.4864H8.85181C8.42792 18.4864 8.07639 18.1372 8.07639 17.7161C8.07639 17.2949 8.42792 16.9457 8.85181 16.9457H20.2246C20.6485 16.9457 21 17.2949 21 17.7161C21 18.1372 20.6485 18.4864 20.2246 18.4864H20.2349ZM4.29236 19C3.57898 19 3 18.4248 3 17.7161C3 17.0073 3.57898 16.4321 4.29236 16.4321C5.00574 16.4321 5.58472 17.0073 5.58472 17.7161C5.58472 18.4248 5.00574 19 4.29236 19ZM4.29236 13.2788C3.57898 13.2788 3 12.7036 3 11.9949C3 11.2861 3.57898 10.7109 4.29236 10.7109C5.00574 10.7109 5.58472 11.2861 5.58472 11.9949C5.58472 12.7036 5.00574 13.2788 4.29236 13.2788ZM4.29236 7.56786C3.57898 7.56786 3 6.99266 3 6.28393C3 5.5752 3.57898 5 4.29236 5C5.00574 5 5.58472 5.5752 5.58472 6.28393C5.58472 6.99266 5.00574 7.56786 4.29236 7.56786ZM20.2349 12.7652H8.85181C8.42792 12.7652 8.07639 12.416 8.07639 11.9949C8.07639 11.5737 8.42792 11.2245 8.85181 11.2245H20.2246C20.6485 11.2245 21 11.5737 21 11.9949C21 12.416 20.6485 12.7652 20.2246 12.7652H20.2349ZM20.2349 7.05429H8.85181C8.42792 7.05429 8.07639 6.70506 8.07639 6.28393C8.07639 5.8628 8.42792 5.51357 8.85181 5.51357H20.2246C20.6485 5.51357 21 5.8628 21 6.28393C21 6.70506 20.6485 7.05429 20.2246 7.05429H20.2349Z"
              fill="currentColor"
            />
          </svg>

          <span :style="{ color: settings?.main?.textColor }">Меню</span>
        </li>
      </ul>
      <div class="phone__swipe-bar"></div>
    </div>
  </div>
</template>
<script>
import { mixWithBase } from '@/services/utils/custom-pages'

export default {
  props: {
    settings: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  computed: {
    bgColor() {
      return this.settings?.main?.fill === 'gradient'
        ? mixWithBase(this.settings?.main?.mainColor, this.settings?.schema)
        : this.settings?.main?.mainColor
    },
  },
}
</script>
<style scoped lang="scss">
.phone {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 520px;
  max-width: 240px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

  &__status-bar {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 10;
  }

  &__content {
    overflow: hidden;
  }

  &__footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    z-index: 10;
  }

  &__swipe-bar {
    margin: 20px auto 8px;
    width: 90px;
    height: 3px;
    border-radius: 999px;
    background-color: #1c1f27;
  }

  &__menu {
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    margin: 0;
  }

  &__menu-item {
    flex: 1 1 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2px;
    margin-top: 8px;
    opacity: 0.4;

    svg {
      color: #000;
      width: 16px;
      height: 16px;
    }

    span {
      font-size: 7px;
      line-height: 9px;
      text-align: center;
      color: #000;
    }
  }

  &__menu-item.active {
    opacity: 1;

    svg {
      color: #f42525;
    }
    span {
      font-weight: 500;
      color: #000;
    }
  }
}

.phone--dark {
  .phone__footer {
    border-top: 1px solid rgba(255, 255, 255, 0.06);
  }

  .phone__menu-item {
    span {
      color: #fff;
    }
    svg {
      color: #fff;
    }
  }

  .phone__menu-item.active {
    svg {
      color: #f42525;
    }

    span {
      color: #fff;
    }
  }

  .phone__swipe-bar {
    background-color: #fff;
  }
}
</style>
